<template>
  <header :class="{ 'header-fixed': true, scrolling: isScrolling }" :style="supportsbackground">
    <nav class="nav-main">
      <div class="brand">
        <svg class="brand-logo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
          version="1.1" width="35.999977111816406" height="23.58822250366211"
          viewBox="0 0 35.999977111816406 23.58822250366211" data-v-9746107e="">
          <g style="mix-blend-mode:passthrough;">
            <g>
              <g style="mix-blend-mode:passthrough;">
                <path
                  d="M0.27554,20.0484C0.27554,20.0484,9.90134,1.31344,9.90134,1.31344C10.785,-0.406398,13.2217,-0.445562,14.1597,1.24499C14.1597,1.24499,24.5153,19.9073,24.5153,19.9073C25.5632,21.7957,23.8108,24.012,21.7399,23.4175C21.7399,23.4175,13.2101,20.9691,13.2101,20.9691C12.776,20.8445,12.3159,20.8444,11.8819,20.9689C11.8819,20.9689,3.08678,23.4904,3.08678,23.4904C1.05174,24.0738,-0.6943,21.936,0.27554,20.0484C0.27554,20.0484,0.27554,20.0484,0.27554,20.0484Z"
                  fill="#3970E3" fill-opacity="1"></path>
              </g>
              <g style="mix-blend-mode:passthrough;">
                <path
                  d="M28.93594544921875,22.2763C28.93594544921875,22.2763,32.91183544921875,23.4175,32.91183544921875,23.4175C34.98273544921875,24.012,36.73503544921875,21.7957,35.68723544921875,19.9073C35.68723544921875,19.9073,25.33164544921875,1.24499,25.33164544921875,1.24499C24.393565449218748,-0.445562,21.95685544921875,-0.406398,21.07322544921875,1.31344C21.07322544921875,1.31344,19.36883544921875,4.63074,19.36883544921875,4.63074C19.36883544921875,4.63074,28.93594544921875,22.2763,28.93594544921875,22.2763C28.93594544921875,22.2763,28.93594544921875,22.2763,28.93594544921875,22.2763Z"
                  fill="#3970E3" fill-opacity="0.5"></path>
              </g>
            </g>
          </g>
        </svg>
        <span class="brand-text">MasterGo</span>
      </div>
      <ul class="nav-section">
        <li v-for="item in navList" :key="item.path">
          <router-link :to="item.path"><span class="nav-name">{{ item.label }}</span></router-link>
        </li>
      </ul>
      <ul class="nav-account">
        <li>
          <router-link to="/login" class="btn-login">登录</router-link>
        </li>
        <li>
          <router-link to="/login" class="btn-gradient-blue-link"><span>免费使用</span></router-link>
        </li>
      </ul>
      <span class="nav-menu-icon" @click="toggleDrawer">
        <span class="icon">
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 24 24"
            style="fill: #666">
            <path
              d="M 2 5 L 2 7 L 22 7 L 22 5 L 2 5 z M 2 11 L 2 13 L 22 13 L 22 11 L 2 11 z M 2 17 L 2 19 L 22 19 L 22 17 L 2 17 z">
            </path>
          </svg>
        </span>
      </span>
    </nav>
    <transition name="slide-fade" appear>
      <div class="menu" v-if="isShowDrawer">
        <div class="head">
          <div class="title">
            <div class="brand">
              <svg class="brand-logo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                version="1.1" width="35.999977111816406" height="23.58822250366211"
                viewBox="0 0 35.999977111816406 23.58822250366211" data-v-9746107e="">
                <g style="mix-blend-mode:passthrough;">
                  <g>
                    <g style="mix-blend-mode:passthrough;">
                      <path
                        d="M0.27554,20.0484C0.27554,20.0484,9.90134,1.31344,9.90134,1.31344C10.785,-0.406398,13.2217,-0.445562,14.1597,1.24499C14.1597,1.24499,24.5153,19.9073,24.5153,19.9073C25.5632,21.7957,23.8108,24.012,21.7399,23.4175C21.7399,23.4175,13.2101,20.9691,13.2101,20.9691C12.776,20.8445,12.3159,20.8444,11.8819,20.9689C11.8819,20.9689,3.08678,23.4904,3.08678,23.4904C1.05174,24.0738,-0.6943,21.936,0.27554,20.0484C0.27554,20.0484,0.27554,20.0484,0.27554,20.0484Z"
                        fill="#3970E3" fill-opacity="1"></path>
                    </g>
                    <g style="mix-blend-mode:passthrough;">
                      <path
                        d="M28.93594544921875,22.2763C28.93594544921875,22.2763,32.91183544921875,23.4175,32.91183544921875,23.4175C34.98273544921875,24.012,36.73503544921875,21.7957,35.68723544921875,19.9073C35.68723544921875,19.9073,25.33164544921875,1.24499,25.33164544921875,1.24499C24.393565449218748,-0.445562,21.95685544921875,-0.406398,21.07322544921875,1.31344C21.07322544921875,1.31344,19.36883544921875,4.63074,19.36883544921875,4.63074C19.36883544921875,4.63074,28.93594544921875,22.2763,28.93594544921875,22.2763C28.93594544921875,22.2763,28.93594544921875,22.2763,28.93594544921875,22.2763Z"
                        fill="#3970E3" fill-opacity="0.5"></path>
                    </g>
                  </g>
                </g>
              </svg>
              <span class="brand-text">MasterGo</span>
            </div>
          </div>
          <svg @click="toggleDrawer" class="icon-close pointer" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
            width="24" height="24" viewBox="0 0 171 171">
            <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
              stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
              font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal">
              <path d="M0,171.99336v-171.99336h171.99336v171.99336z" fill="none"></path>
              <g fill="#000000">
                <path
                  d="M26.39813,21.48188l-4.91625,4.91625l59.10187,59.10188l-59.10187,59.10188l4.91625,4.91625l59.10188,-59.10187l59.10188,59.10187l4.91625,-4.91625l-59.10187,-59.10188l59.10187,-59.10187l-4.91625,-4.91625l-59.10188,59.10187z">
                </path>
              </g>
            </g>
          </svg>
        </div>
        <ul>
          <li v-for="item in navList" :key="item.path">
            <router-link class="link" :to="item.path">
              {{ item.label }}
            </router-link>
          </li>
          <li>
            <router-link to="/login" class="link">立即登录</router-link>
          </li>
        </ul>
      </div>
    </transition>
  </header>
</template>

<script>
export default {
  name: "header-fixed",
  data() {
    return {
      isScrolling: false,
      isSupports: false,
      isShowDrawer: false,
      navList: [
        {
          path: "/",
          label: "产品",
        },
        {
          path: "/pricing",
          label: "价格",
        },
        {
          path: "/download",
          label: "下载",
        },
        {
          path: "/dynamic",
          label: "最新动态",
        },
      ],
    };
  },
  computed: {
    // 根据浏览器是否支持css的backdrop-filter属性决定
    supportsbackground() {
      return this.isSupports ? "background: transparent" : "";
    },
  },
  mounted() {
    window.onscroll = function () {
      var scrollPos;
      if (window.pageYOffset) {
        scrollPos = window.pageYOffset;
      } else if (document.compatMode && document.compatMode != "BackCompat") {
        scrollPos = document.documentElement.scrollTop;
      } else if (document.body) {
        scrollPos = document.body.scrollTop;
      }
      this.isScrolling = scrollPos > 0;
    }.bind(this);
    this.isSupports = CSS.supports("backdrop-filter", "blur(24px)"); // 是否支持backdrop-filter
  },
  methods: {
    toggleDrawer() {
      this.isShowDrawer = !this.isShowDrawer;
    },
  },
  watch: {
    $route: function () {
      // 路由改变时执行
      // console.log("to.path:" + to.path);
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    },
  }
};
</script>

<style>
.page-padding {
  padding-top: 65px;
}
</style>
<style scoped>
/* 可以为进入和离开动画设置不同的持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.22s ease;
}

.slide-fade-leave-active {
  transition: all 0.22s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

.header-fixed {
  position: fixed;
  left: 0;
  right: 0;
  height: 65px;
  box-shadow: none;
  -webkit-box-shadow: none;
  z-index: 1000;
}

.header-fixed.scrolling {
  -webkit-box-shadow: 0 4px 30px rgb(0 0 0 / 7%);
  box-shadow: 0 4px 30px rgb(0 0 0 / 7%);
  -webkit-backdrop-filter: blur(24px);
  backdrop-filter: blur(24px);
  background-color: hsla(0, 0%, 100%, 0.75);
}

.nav-main {
  display: -ms-flexbox;
  display: flex;
  height: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 40px;
  align-items: center;
  transition: padding 0.2s;
}

.brand {
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 1rem;
}

.brand-text {
  margin-left: 1rem;
  width: 145px;
  height: 22px;
  text-align: left;
  font-size: 20px;
  line-height: 22px;
  font-weight: 700;
}

.nav-section {
  margin: 0;
  display: -ms-flexbox;
  display: flex;
  -ms-flex: 1 1;
  flex: 1 1;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: center;
  align-items: center;
}

.nav-section>li {
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  height: 100%;
  font-size: 16px;
  margin-right: 16px;
  padding-left: 10px;
  padding-right: 8x;
  position: relative;
}

.nav-section>li>a {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  height: 100%;
  position: relative;
  padding-left: 4px;
  padding-right: 4px;
  transition: 0ms;
}

.nav-account {
  display: -ms-flexbox;
  display: flex;
  position: relative;
  justify-content: flex-end;
  align-items: center;
  margin: 0;
}

.nav-account>li>a {
  display: -ms-flexbox;
  display: flex;
  font-size: 16px;
  line-height: 1;
  padding: 12px 16px;
  -webkit-transition: all 218ms;
  transition: all 218ms;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.nav-account>li a.btn-gradient-blue-link {
  padding: 6px 20px;
  border: 2px solid #1b9aee;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  font-size: 16px;
  line-height: 24px;
  color: #1b9aee;
  border-radius: 13px;
  font-weight: 500;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

.nav-main>.nav-menu-icon {
  display: none;
}

.nav-main>.nav-menu-icon>.icon {
  float: right;
  margin: 0 1rem;
  cursor: pointer;
  transition: transform 0.2s;
}

.nav-main>.nav-menu-icon>.icon:hover,
.menu>.head>.icon-close:hover {
  -o-transform: scale(1.25);
  -ms-transform: scale(1.25);
  -moz-transform: scale(1.25);
  -webkit-transform: scale(1.25);
  transform: scale(1.25);
}

.menu {
  position: fixed;
  top: 0;
  left: 12px;
  right: 12px;
  background: #fff;
  visibility: hidden;
  box-shadow: 0 50px 100px rgb(50 50 93 / 10%), 0 15px 35px rgb(50 50 93 / 15%), 0 5px 15px rgb(0 0 0 / 10%);
}

.menu>.head {
  height: 65px;
  line-height: 65px;
  display: flex;
  align-items: center;
}

.menu>.head>.title {
  flex: 1;
}

.menu>.head>.icon-close {
  height: 65px;
  margin-right: 1.5rem;
  transition: transform 0.2s;
}

.menu>ul {
  margin: 0 1.2rem 1rem;
  border-top: 1px solid #ddd;
}

.menu>ul>li>.link {
  display: inline-block;
  width: 100%;
  box-sizing: border-box;
  padding: 1rem 0;
  font-size: 1.25rem;
}

@media (max-width: 900px) {
  .nav-account {
    padding: 0;
  }

  .nav-section>li {
    margin-right: 8px;
    padding-left: 8px;
  }

  .nav-main {
    padding: 0 16px;
  }
}

@media (max-width: 765px) {
  .menu {
    visibility: unset;
  }

  .nav-main>.nav-menu-icon {
    display: unset;
  }

  .nav-section {
    display: none;
  }

  .nav-account {
    display: none;
  }
  .brand {
    flex: 1;
  }
}
</style>